<template>
  <li v-show="currentVisibled"
      :class="treeNodeClasses"
  >
    <span class="subline" :style="{left:indentStyle.paddingLeft}"></span>
    <div :class="treeNodeContentClasses" :style="indentStyle" data-role="tree-node-handle" :data-node-id="currentNodeModel.id">
      <div :class="treeNodeTitleClasses" class="h-100" :data-node-id="currentNodeModel.id">
        <div :style="innerIndentStyle" class="float-right w-100 h-100">
          <template v-if="currentNodeRender !== null">
            <t-tree-node-custom-content :node-render="currentNodeRender" :node-model="currentNodeModel" />
          </template>
          <template v-else>
            <span :class="labelClasses"
                  :title="nodeTitle"
                  :data-node-id="currentNodeModel.id"
                  data-role="tree-node-label"
            >{{ currentNodeModel.label }}</span>
          </template>
        </div>
        <i
          v-if="hasChildren || currentNodeModel.children"
          data-role="tree-node-handle"
          :class="handleClasses"
          :data-node-id="currentNodeModel.id"
        />
        <i v-if="currentLoading" :class="loadingClasses" />
        <!-- 复用复选框样式类 -->
        <label v-if="currentMultiple" :class="checkboxClasses">
          <span data-role="tree-node-checkbox"
                :data-node-id="currentNodeModel.id"
                :class="checkboxInnerClasses"
          ></span>
        </label>
        <i v-if="nodeIconVisibled" :class="nodeIconClasses" />
      </div>
    </div>
    <template v-if="currentNodeModel.childCount > 0">
      <ul v-show="currentExpanded"
          :class="subTreeClasses"
      >
        <t-tree-node
          v-for="subNodeModel in currentNodeModel.children"
          :key="subNodeModel.id"
          :data-key="subNodeModel.id"
          :node-key="nodeKey"
          :multiple="currentMultiple"
          :node-render="nodeRender"
          :horizontal-scroll="horizontalScroll"
          :auxiliary-line="auxiliaryLine"
          :node-model="subNodeModel"
        ></t-tree-node>
      </ul>
    </template>
  </li>
</template>
<script>
import TTreeNodeCustomContent from './tree-node-custom-content'
import { PREFIX_CLASS, CLASS_MAIN, PREFIX_ICON_CLASS } from '../../utils/constants'
import { TreeNode } from './tree-model'
import bus from '../../utils/bus'
import {
  BUS_TREE__SELECT
} from './constants'
const PREFIX_TREE_NODE_CLASS = `${PREFIX_CLASS}tree__node`
const PREFIX_CHECKBOX_CLASS = `${PREFIX_CLASS}form-checkbox`
const PREFIX_SUB_TREE_CLASS = `${PREFIX_CLASS}tree__child-tree`
const ICON_SIZE = 14
const GAP = 4

export default {
  name: 'TTreeNode',
  components: {
    TTreeNodeCustomContent
  },
  inject: {
    owner: 'owner'
  },
  props: {
    nodeRender: {
      type: Function,
      default: null
    },
    dataKey: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    },
    nodeModel: {
      type: Object,
      required: true,
      validator(val) {
        return val instanceof TreeNode
      }
    },
    nodeKey: {
      type: String,
      default: '' // 将使用模型默认值
    },
    horizontalScroll: {
      type: Boolean,
      default: false
    },
    auxiliaryLine: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentMultiple: false,
      currentAuxiliaryLine: false,
      currentNodeModel: null
    }
  },
  computed: {
    nodeIconVisibled() {
      let nodeModel = this.currentNodeModel
      if ((this.currentExpanded && nodeModel.expandedIcon !== '') ||
        (this.currentExpanded === false && nodeModel.foldedIcon !== '') ||
        (nodeModel.isLeaf && nodeModel.leafIcon !== '')) {
        return true
      }
      return false
    },
    hasChildren() {
      return (this.currentNodeModel.visiableChildCount > 0 && this.currentNodeModel.childCount > 0) || this.currentNodeModel.lazy
    },
    checkboxInnerClasses() {
      return `${PREFIX_CHECKBOX_CLASS}__inner`
    },
    checkboxClasses() {
      let arr = [ PREFIX_CHECKBOX_CLASS ]
      const { indeterminate, selected, disabled } = this.currentNodeModel
      if (disabled) {
        arr.push(`${PREFIX_CHECKBOX_CLASS}--disabled`)
        return arr
      }
      if (indeterminate) {
        arr.push(`${PREFIX_CHECKBOX_CLASS}--indeterminate`)
      } else if (selected) {
        arr.push(`${PREFIX_CHECKBOX_CLASS}--checked`)
      }
      return arr
    },
    currentLoading() {
      return this.currentNodeModel.loading
    },
    nodeTitle() {
      return this.currentNodeModel.title || this.currentNodeModel.label
    },
    subTreeClasses() {
      return PREFIX_SUB_TREE_CLASS
    },
    nodeIconClasses() {
      let icon
      let nodeModel = this.currentNodeModel
      if (nodeModel.isLeaf && nodeModel.leafIcon !== '') {
        icon = nodeModel.leafIcon
      } else {
        icon = this.currentExpanded ? nodeModel.expandedIcon : nodeModel.foldedIcon
      }
      return [
        PREFIX_ICON_CLASS.replace('-', ''),
        `${PREFIX_TREE_NODE_CLASS}-icon`,
        `${PREFIX_ICON_CLASS}${icon}`
      ]
    },
    handleClasses() {
      let icon
      if (this.auxiliaryLine) {
        icon = this.currentExpanded ? this.currentNodeModel.handleExpandedIcon2 : this.currentNodeModel.handleFoldedIcon2
      } else {
        icon = this.currentExpanded ? this.currentNodeModel.handleExpandedIcon : this.currentNodeModel.handleFoldedIcon
      }
      return [
        PREFIX_ICON_CLASS.replace('-', ''),
        `${PREFIX_TREE_NODE_CLASS}-handle`,
        `${PREFIX_TREE_NODE_CLASS}-icon`,
        `${PREFIX_ICON_CLASS}${icon}`
      ]
    },
    loadingClasses() {
      return [
        `${PREFIX_ICON_CLASS}ani-loop`,
        CLASS_MAIN,
        `${PREFIX_ICON_CLASS}loading`,
        `${PREFIX_TREE_NODE_CLASS}-icon`
      ]
    },
    labelClasses() {
      return [
        `${PREFIX_TREE_NODE_CLASS}-text`,
        {
          [`${PREFIX_TREE_NODE_CLASS}-text-hight`]: !this.owner.rowHighlight,
          'tree__node-light-width': this.owner.rowHighlight
        },
        {
          [`${PREFIX_TREE_NODE_CLASS}-text--checked`]: this.currentMultiple === false && this.currentNodeModel.selected, // && !this.owner.rowHighlight  2021.3.11 客户提出需求在rowHighlight下selected无效，故取消这个限制条件
          [`${PREFIX_TREE_NODE_CLASS}-light-text`]: this.currentNodeModel._searchLabel
        }
      ]
    },
    innerIndentStyle() {
      let nodeModel = this.currentNodeModel
      let iconNum = 0
      let val = 0
      if ((nodeModel.childCount > 0 && nodeModel.visiableChildCount > 0) || nodeModel.lazy === true) {
        iconNum++
      }
      if (this.multiple) {
        iconNum++
      }
      if ((this.currentExpanded && nodeModel.expandedIcon !== '') ||
        (this.currentExpanded === false && nodeModel.foldedIcon !== '') ||
        (nodeModel.isLeaf && nodeModel.leafIcon !== '')) {
        iconNum++
      }
      if (iconNum >= 1) {
        val += ICON_SIZE * iconNum + GAP * (iconNum - 1)
      }
      if (this.currentNodeModel.children && !this.hasChildren) {
        return {
          paddingLeft: this.currentNodeModel.children ? `${val + ICON_SIZE}px` : `${val}px`
        }
      } else {
        return {
          paddingLeft: this.nodeModel.loading ? `${val + ICON_SIZE}px` : `${val}px`
        }
      }
    },
    hasNodeIcon() {
      let nodeModel = this.currentNodeModel
      if ((this.currentExpanded && nodeModel.expandedIcon !== '') ||
        (this.currentExpanded === false && nodeModel.foldedIcon !== '')) {
        return true
      }
      return false
    },
    indentStyle() {
      let nodeModel = this.currentNodeModel
      let val
      if (nodeModel.isRoot) {
        val = ((nodeModel.childCount === 0 && !this.currentAuxiliaryLine) && nodeModel.lazy === false) ? ICON_SIZE : 0
        if (this.multiple === false && nodeModel.isLeaf && this.hasNodeIcon) {
          val += GAP
        }
      } else {
        val = ICON_SIZE * nodeModel.level
      }
      if (!nodeModel.isRoot && !(nodeModel.childCount > 0) && !this.nodeIconVisibled) {
        val += ICON_SIZE
      }
      if (this.multiple && nodeModel.childCount === 0 && nodeModel.lazy === false) {
        val += GAP
      }
      if (!nodeModel.isRoot) {
        if (nodeModel.childCount === 0 && !this.currentAuxiliaryLine && nodeModel.lazy === false && this.hasNodeIcon) {
          val += ICON_SIZE
        }
        if (nodeModel.visiableChildCount <= 0 && nodeModel.childCount !== 0) {
          val += GAP
        }
      }
      return {
        paddingLeft: `${val}px`
      }
    },
    treeNodeContentClasses() {
      return {
        [`${PREFIX_TREE_NODE_CLASS}-content`]: true,
        // [`${PREFIX_TREE_NODE_CLASS}-content--checked`]: this.currentNodeModel.selected,
        'w-100': true,
        [`${PREFIX_TREE_NODE_CLASS}-high-light`]: this.owner.rowHighlight,
        [`${PREFIX_TREE_NODE_CLASS}__hight-light`]: this.currentNodeModel.lineLight,
        [`${PREFIX_TREE_NODE_CLASS}__disabled`]: this.currentNodeModel.disabled
      }
    },
    treeNodeClasses() {
      return {
        [`${PREFIX_TREE_NODE_CLASS}`]: true,
        [`${PREFIX_TREE_NODE_CLASS}--open`]: this.currentExpanded,
        [`${PREFIX_TREE_NODE_CLASS}-leaf`]: this.currentNodeModel.isLeaf
      }
    },
    treeNodeTitleClasses() {
      return {
        'd-inline-block': this.currentHorizontalScroll,
        [`${PREFIX_TREE_NODE_CLASS}--open`]: this.currentExpanded,
        [`${PREFIX_TREE_NODE_CLASS}-leaf`]: this.currentNodeModel.isLeaf,
        [`${PREFIX_TREE_NODE_CLASS}-title`]: true,
        'text-nowrap': true
      }
    },
    currentVisibled() {
      return this.currentNodeModel.visibled
    },
    currentExpanded() {
      return this.currentNodeModel.expanded
    },
    nodeId() {
      return this.currentNodeModel.id
    }
  },
  watch: {
    nodeModel(val) {
      this.currentNodeModel = val
    },
    horizontalScroll(val) {
      this.currentHorizontalScroll = val
    },
    auxiliaryLine(val) {
      this.currentAuxiliaryLine = val
    }
  },
  created() {
    this.currentMultiple = this.multiple
    this.currentAuxiliaryLine = this.auxiliaryLine
    this.currentNodeRender = this.nodeRender
    this.currentNodeModel = this.nodeModel
    this.currentHorizontalScroll = this.horizontalScroll
  },
  methods: {
    $_onCheckboxChange() {
      bus.$emit(BUS_TREE__SELECT, this.owner, this.nodeId, !this.currentNodeModel.selected)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/tree/tree-node.vue